export default __webpack_public_path__ + "static/media/FastTrack_Appointments_224x224.298a7ca2.jpg";